import React from 'react';
import { NavLink } from 'react-router-dom';

import '../assets/css/menu.css';

const MenuInferiorAdmin = () => {
  return (
    <div>
      <nav className="menuinferior-admin">
        <ul>
          <li style={{ display: 'none' }}>
            <NavLink to="" exact activeClassName="active">
              <span className="material-icons icono-menuinferior-admin">support_agent</span>
            </NavLink>
          </li>

          <li style={{ display: 'none' }}>
            <NavLink to="" exact activeClassName="active">
              <span className="material-icons icono-menuinferior-admin">videocam</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin-dashboard/events/critical/recent"
              className="ico-notification"
              exact
              activeClassName="active"
              aria-label="Eventos críticos recientes"
              title="Eventos críticos recientes"
            />
          </li>

          <li style={{ display: 'none' }}>
            <NavLink to="" exact activeClassName="active">
              <span className="material-icons icono-menuinferior-admin">security</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/admin-dashboard"
              className="ico-cartelera"
              exact
              activeClassName="active"
              aria-label="Inicio administración"
              title="Inicio administración"
            />
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default MenuInferiorAdmin;
